import { Model } from './model';
import { Type } from 'class-transformer';
import { DateTimeRange, IntRange } from './types';

export type FieldType = 'any' | 'array' | 'boolean' | 'number' | 'object' | 'string';

export type FieldFormat =
  | 'binary'
  | 'byte'
  | 'color'
  | 'date'
  | 'datetime'
  | 'decimal'
  | 'email'
  | 'enum'
  | 'float'
  | 'hostname'
  | 'password'
  | 'tel'
  | 'text'
  | 'time'
  | 'timestamp'
  | 'timezone'
  | 'uri'
  | 'uuid';

export type FieldInputFormat = 'checkbox' | 'dropdown' | 'radio' | 'range';

export class Field extends Model {
  choices: FieldChoice[];

  description: string | null;

  display_name: string | null;

  format: FieldFormat | null;

  is_required: boolean;

  items: FieldItemType[] | null;

  key: string;

  label: string | null;

  @Type(() => FieldRequirements)
  requirements: FieldRequirements | null;

  type: FieldType;
}

export interface FieldChoice {
  label: string;

  value: number | string;
}

export interface FieldItemType {
  type: FieldType;

  format: FieldFormat | null;

  items: FieldItemType[] | null;
}

export class FieldRequirements {
  date_allow_future: boolean;

  @Type(() => DateTimeRange)
  date_range: DateTimeRange | null;

  @Type(() => DateTimeRange)
  datetime_range: DateTimeRange | null;

  @Type(() => IntRange)
  numeric_range: IntRange | null;

  @Type(() => IntRange)
  text_length: IntRange | null;
}
